export function waitForRouteTransition(ms = 120) {
  return new Promise(resolve => {
    requestAnimationFrame(() => setTimeout(resolve, ms));
  });
}
